import React from 'react';
import { Loader2, Check, X, ChevronRight, ListChecks } from 'lucide-react';
import ToolChip from './ToolChip';
import { toolMeta } from './chatHelpers';

// Mobile: a run of consecutive tool calls folds into one "N steps" row, so the transcript reads
// as conversation with the work tucked behind it. Open it to see every step (and its output).
export default function ToolGroup({ tools }) {
  if (tools.length === 1) return <ToolChip item={tools[0]} />;
  const running = tools.filter((t) => !t.done);
  const failed = tools.filter((t) => t.done && t.isError).length;
  const state = running.length ? 'run' : failed ? 'err' : 'ok';
  const last = tools[tools.length - 1];
  const lastLabel = toolMeta(last.name, last.input, last.done).label;
  return (
    <details className={`cc-tool cc-group cc-tool-${state}`} open={state === 'err' ? true : undefined}>
      <summary className="cc-tool-summary">
        <ChevronRight size={14} className="cc-tool-caret" />
        <ListChecks size={15} className="cc-tool-icon" />
        <span className="cc-tool-label">
          {tools.length} steps{failed ? ` · ${failed} failed` : ''}
          <span className="cc-group-last"> · {lastLabel}</span>
        </span>
        <span className="cc-tool-state" aria-label={state === 'run' ? 'running' : state === 'err' ? 'some failed' : 'all done'}>
          {state === 'run' ? <Loader2 size={14} className="cc-spin" /> : state === 'err' ? <X size={14} /> : <Check size={14} />}
        </span>
      </summary>
      <div className="cc-group-body">{tools.map((t) => <ToolChip key={t.key} item={t} />)}</div>
    </details>
  );
}
